import React, { useEffect } from 'react'
import { SiteHeader } from '../components/site-header'
import { ConsultantsSection } from '../components/team/consultants-section'
import { TestimonialsSection } from '../components/shared/testimonials-section'
import { ContactCtaSection } from '../components/shared/cta-section'
import { PageHero } from '../components/ui/page-hero'
import { METADATA } from '../components/meta/metadata'

export default function MeetTheTeamPage() {
  // Set metadata for the page
  useEffect(() => {
    document.title = METADATA.meetTheTeam.title;
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', METADATA.meetTheTeam.description);
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <PageHero
          title="Who We Are"
          description="Our senior team brings over 100 years of combined experience across technology leadership, programme delivery and complex transformation. We've built products serving millions of users, led multi-billion pound programmes and scaled organisations through high-stakes change. We bring this leadership depth to AI implementation, combining knowledge engineering methodology with practical operational understanding."
          backgroundImage="/images/backgrounds/flickr-473770493.jpg"
          backgroundAlt="Who We Are"
        />
        <div className="relative">
          <ConsultantsSection />
          <TestimonialsSection className="bg-primary/5" />
          <ContactCtaSection className="plain" spacingClass="py-20 pb-32" />
        </div>
      </main>
    </div>
  )
} 